import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { EnvironmentOutlined, GlobalOutlined, LinkOutlined } from "@ant-design/icons";

import { IAddress, ICountry, IShipco, IShipcoGroup } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const AddressCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IAddress>({ redirect: "list" });

  const { selectProps: countrySelectProps } = useSelect<ICountry>({
    resource: "country",
    optionLabel: "name",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  const { selectProps: shipcoSelectProps } = useSelect<IShipco>({
    resource: "shipco",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  const { selectProps: shipcoGroupSelectProps } = useSelect<IShipcoGroup>({
    resource: "shipco-group",
    optionLabel: "registrationName",
    optionValue: "id",
    pagination: { mode: "server" }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "setup new address",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Address Details"
            subtitle="Street address information"
            icon={<EnvironmentOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={1}>
              <Form.Item
                label="Address Line 1"
                name="addressLine1"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
            <FormFieldGrid columns={2}>
              <Form.Item label="Address Line 2" name="addressLine2">
                <Input />
              </Form.Item>
              <Form.Item label="Address Line 3" name="addressLine3">
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Location"
                subtitle="City, state and country"
                icon={<GlobalOutlined />}
              >
                <FormFieldGrid columns={2}>
                  <Form.Item
                    label="City"
                    name="city"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="State"
                    name="state"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item label="Postal Code" name="postalCode">
                    <Input />
                  </Form.Item>
                </FormFieldGrid>
                <Form.Item
                  label="Country"
                  name={["country", "id"]}
                  rules={[{ required: true }]}
                >
                  <Select {...countrySelectProps} />
                </Form.Item>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Company Association"
                subtitle="Link to company (optional)"
                icon={<LinkOutlined />}
              >
                <Form.Item label="Shipco" name={["shipco", "id"]}>
                  <Select {...shipcoSelectProps} />
                </Form.Item>
                <Form.Item label="Shipco Group" name={["shipcoGroup", "id"]}>
                  <Select {...shipcoGroupSelectProps} />
                </Form.Item>
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Create>
  );
};
